// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  AdFleetMapAreaId,
  AdFleetMapAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import { AdFleetMapAreaNavigation } from './AdFleetMapAreaNavigation'

const LazyAdFleetMapComponent = lazy(() => import('./AdFleetMapArea'))

const AdFleetMapComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAdFleetMapComponent />
  </SuspenseLoadingWrapper>
)

export const AdFleetMapArea = {
  id: AdFleetMapAreaId,
  requiredRight: BoumRight.AREA_AD_FLEET_MAP,
  NavigationComponent: AdFleetMapAreaNavigation,
  route: {
    path: AdFleetMapAreaRoutes.route,
    component: AdFleetMapComponent,
  },
}
